import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PracticeAreas } from './components/PracticeAreas';
import { Team } from './components/Team';
import { Experience } from './components/Experience';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-grayLightest text-grayDarkest selection:bg-grayDarkest selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <PracticeAreas data-id="element-5" />
        <Team data-id="element-6" />
        <Experience data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CTASection data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}